/**
 * Generated runtime TestId mirror for frontend/src/components/restriction-rules/ReviewInfoCard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const ReviewInfoCardTestIds = {
  cardTitleReviewInfo: "card-title-review-info",
  linkReviewedBy: "link-reviewed-by",
  reviewInfoCard: "review-info-card",
  reviewInfoComment: "review-info-comment",
  reviewInfoReviewedAt: "review-info-reviewed-at",
  reviewInfoReviewer: "review-info-reviewer"
} as const;
